import { useQuery } from '@apollo/client';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ChangeEvent, FC, useEffect, useState } from 'react';
import Input from '../../../../../components/form/input';
import { CLINICS_GET } from '../../../../../graphql/query/clinics';
import { USERS_CLINICIAN_LIST, USERS_CLINIC_ADMIN_LIST } from '../../../../../graphql/query/users';
import useAuth from '../../../../../hooks/auth';
import { Clinic, GraphQLResponse, GraphQLResponseTitan, IUser } from '../../../../../types';
import UsersManageClinicianList from '../../clinician/list';
import UsersManageAdminList from './list';
import styles from './styles.module.css';

const UsersManageClinicAdminView: FC = () => {
  const [filter, setFilter] = useState('');
  const [availableClinics, setAvailableClinics] = useState<Clinic[]>([]);
  const { user: currentUser } = useAuth();

  const userClinics = currentUser?.acl?.clinics || [];

  const {
    loading: loadingUsers,
    data: resUsers,
    refetch: searchUsers,
  } = useQuery<GraphQLResponse<'listUsersClinicAdmin', IUser[]>>(USERS_CLINIC_ADMIN_LIST, {
    variables: { filter: filter.length >= 3 ? filter : '' },
  });

  const {
    loading: loadingClinicians,
    data: resClinicians,
    refetch: searchClinicians,
  } = useQuery<GraphQLResponse<'listUsersClinician', IUser[]>>(USERS_CLINICIAN_LIST, {
    variables: { filter: filter.length >= 3 ? filter : '' },
  });

  const dataUsers = resUsers?.listUsersClinicAdmin?.data;
  const dataClinicians = resClinicians?.listUsersClinician?.data;

  const { data: dataClinics } = useQuery<GraphQLResponseTitan<'clinics', Clinic[]>>(CLINICS_GET);

  // set up clinics for options
  useEffect(() => {
    if (dataClinics?.clinics) {
      // set available clinics for use in form
      setAvailableClinics(
        dataClinics.clinics.filter(c =>
          userClinics.map(s => s.toString()).includes(c.id.toString())
        )
      );
    }
  }, [dataClinics, userClinics]);

  const handleUpdateFilter = (e: ChangeEvent<HTMLInputElement>) => {
    setFilter(e.target.value);
  };

  const handleRefreshList = () => {
    searchUsers();
    searchClinicians();
  };

  return (
    <>
      <div className={styles.wrapper}>
        {/* header area */}
        <div className={styles.header}>
          <div className={styles.inputWrapper}>
            <Input.Component
              placeholder="Search for user..."
              value={filter}
              onChange={handleUpdateFilter}
              style={{
                width: '100%',
                border: '0',
                backgroundColor: 'transparent',
                padding: '1rem 2rem 1rem 2.5rem',
              }}
              controlProps={{
                style: {
                  width: '100%',
                },
              }}
              iconLeft={
                <FontAwesomeIcon icon={faSearch as IconProp} className={styles.inputIcon} />
              }
            />
          </div>
        </div>

        <UsersManageAdminList
          show={dataUsers}
          isLoading={loadingUsers}
          refresh={handleRefreshList}
          availableClinics={availableClinics}
        />
      </div>

      {/* display list of clinicians also for clinic admins, with editing capabilities */}
      <div className={styles.subtitleWrapper}>
        <span className={styles.subtitle}>Manage Clinician users</span>
      </div>

      <UsersManageClinicianList
        show={dataClinicians}
        isLoading={loadingClinicians}
        refresh={handleRefreshList}
      />
    </>
  );
};

export default UsersManageClinicAdminView;
